import { NgTemplateOutlet } from '@angular/common'
import { Component, computed, input } from '@angular/core'
import { RouterLink } from '@angular/router'
import { Color } from '../design-system'
import { Icon, IconComponent } from '../icon'

interface MenuItemBase {
  label: string
  icon?: Icon
  iconColor?: Color
  labelColor?: Color
  openInNewWindow?: boolean
  hideOpenInNewWindowIcon?: boolean
}

export interface MenuItemLink extends MenuItemBase {
  path: string[]
}

export interface MenuItemButton extends MenuItemBase {
  action: () => void
  isDestructive?: boolean
  isSelected?: boolean
}

export type MenuItem = MenuItemBase | MenuItemLink | MenuItemButton

@Component({
  selector: 'ftr-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.css'],
  imports: [IconComponent, RouterLink, NgTemplateOutlet],
})
export class MenuItemComponent {
  readonly menuItem = input.required<MenuItem>()

  readonly defaultIconColor = computed<Color>(() => {
    const item = this.menuItem()
    return this.isButton(item) && item.isDestructive ? Color.Error50 : Color.Grey40
  })

  readonly shouldShowOpenInNewWindowIcon = computed<boolean>(() => {
    const item = this.menuItem()
    return item.openInNewWindow === true && item.hideOpenInNewWindowIcon !== true
  })

  protected isLink(menuItem: MenuItem): menuItem is MenuItemLink {
    return 'path' in menuItem
  }

  protected isButton(menuItem: MenuItem): menuItem is MenuItemButton {
    return 'action' in menuItem
  }

  protected isSelectableButton(menuItem: MenuItem): menuItem is MenuItemButton {
    return 'isSelected' in menuItem
  }
}
